import { ProjectCollectionOutline } from '@deepup/icons';
import {
  type ActivityStateFilterMode,
  filterProjectsByActivityState,
} from '@projects/pages/list/filterProjectsByActivityState';
import {
  type LabelingFilterMode,
  filterProjectsByLabeling,
} from '@projects/pages/list/filterProjectsByLabeling';
import { projectSelectors } from '@projects/redux';
import { useSelector } from 'react-redux';
import { ProjectListSection } from './ProjectListSection';
import { ProjectsTable } from './ProjectsTable';

export const ProjectListAll = ({
  search,
  labelingFilter,
  activityStateFilter,
}: {
  search: string;
  labelingFilter: LabelingFilterMode;
  activityStateFilter: ActivityStateFilterMode;
}) => {
  const allProjects = useSelector(projectSelectors.selectAll);
  const labelingFiltered = filterProjectsByLabeling(allProjects, labelingFilter);
  const rows = filterProjectsByActivityState(labelingFiltered, activityStateFilter);

  return (
    <div>
      <ProjectListSection
        primaryText="All Projects"
        secondaryText={rows.length}
        Icon={ProjectCollectionOutline}
      />
      <ProjectsTable rows={rows} pagination search={search} />
    </div>
  );
};
